<template>
    <div class="block-amount">
        <ul>
            <li>
                <span class="title">房源總量</span>
                <span class="group">
                    <span class="amount">{{dashboard.totalHouse}}</span>
                    <span class="measure">間</span>
                </span>
            </li>
            <li>
                <span class="title">欠租總額</span>
                <span class="group">
                    <span class="amount">{{toCurrency(dashboard.totalBill)}}</span>
                    <span class="measure">元</span>
                </span>
            </li>
            <li>
                <span class="title">空房間</span>
                <span class="group">
                    <span class="amount">{{dashboard.totalReveal}}</span>
                    <span class="measure">間</span>
                </span>
            </li>
            <li>
                <span class="title">出租率</span>
                <span class="group">
                    <span class="amount">{{dashboard.rentPercent}}</span>
                </span>
            </li>
        </ul>
    </div>
</template>
<script>
import { apiGetDashboard } from "@/apis/api.js"; 

export default {
    name: 'BlockAmount',
    data () {
        return {
            dashboard: ''
        }
    },
    mounted () {
        this.getDashboard()
    },
    methods: {
        getDashboard : function () {
            apiGetDashboard()
            .then(res => {
                this.dashboard = res.data.result
                // console.log(res)
            })
            .catch(err => {
                console.log(err)
            })
        },
        // toCurrency: function (num){
        //     if(num){
        //         var parts = num.toString().split('.');
        //         // console.log(parts);
        //         parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //         return parts.join('.');
        //     }else{
        //         return 0
        //     }
        // },
    }
}
</script>
<style scoped lang="scss">
    .block-amount{
        position: relative;
        width: 1104px;
        height: 27px;
        background: #fff;
        border: solid 1px #f0f0f0;
        border-radius: 10px;
        padding: 20px 24px;
        display: flex;
        align-items: center;
        ul{
            display: flex;

            li{
                position: relative;
                width: 223px;
                display: flex;
                align-items: center;
                border-right: 1px solid #f0f0f0;
                padding-right: 35px;
                margin-right: 35px;
                height: 37px;
                .title{
                    color: #a8a5a4;
                }
                .group{
                    position: absolute;
                    right: 35px;
                    span{
                        font-size: 20px;
                        letter-spacing: 0.22px;
                        color: #292625;
                    }
                }
            }
            li:last-child{
                padding-right: 0px;
                margin-right: 0px;
                border-right: 0px;

            }
        }
    }
    @media screen and (max-width: 1280px) {
        .block-amount{
            width: 1095px;
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/BlockAmount.vue